/**
 * Number Input Widget for RUL Forms
 */

import { InputNumber } from 'antd';
import type { NumberInputWidget } from '@/api/types/rul.types';

interface NumberInputWidgetProps {
  widget: NumberInputWidget;
  onChange: (name: string, value: any) => void;
  error?: string;
}

export const NumberInputWidgetComponent: React.FC<NumberInputWidgetProps> = ({
  widget,
  onChange,
  error,
}) => {
  if (!widget.visible) return null;

  return (
    <div className="rul-field">
      {widget.label && (
        <label className="rul-field-label">
          {widget.label}
          {widget.required && <span className="rul-field-required">*</span>}
        </label>
      )}
      <InputNumber
        value={widget.value}
        placeholder={widget.placeholder}
        disabled={!widget.enabled}
        status={error ? 'error' : undefined}
        min={widget.min}
        max={widget.max}
        step={widget.step}
        style={{ width: '100%' }}
        onChange={(value) => onChange(widget.name, value)}
      />
      {widget.help_text && !error && (
        <div className="rul-field-help">{widget.help_text}</div>
      )}
      {error && <div className="rul-field-error">{error}</div>}
    </div>
  );
};
